const doc = [({"en":({"js":({"users":({"passwords":({"edit":({"index":({"your_password_was_changed":"Your password was changed."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;